module.exports = __webpack_public_path__ + "img/plane-icon.b995fa78.svg";